import { gql, useQuery } from '@apollo/client';

export const GET_LOCATION_DATEV_NUMBERS = gql`
  query getLocationsAssignedDatevNumbers {
    getLocationsAssignedDatevNumbers {
      _id
      location
      company
      datevNumber
    }
  }
`;

export const useGetLocationsAssignedDatevNumbers = () => {
  const { data, loading } = useQuery(GET_LOCATION_DATEV_NUMBERS, {
    fetchPolicy: 'network-only',
  });

  const datevNumbers = data?.getLocationsAssignedDatevNumbers || [];

  return {
    datevNumbers,
    loading,
  };
};
